import {
  CREATE_MEDIA_ALL_INFO_PATIENT_FAIL,
  CREATE_MEDIA_ALL_INFO_PATIENT_REQUEST,
  CREATE_MEDIA_ALL_INFO_PATIENT_SUCCESS,
  CREATE_MEDIA_INFORMATION_FAIL,
  CREATE_MEDIA_INFORMATION_REQUEST,
  CREATE_MEDIA_INFORMATION_SUCCESS,
} from "../../ActionType/MediaInformationType/MediaInformation";
import { api } from "../../Api/api";
import { getToken } from "../login";
import swal from "sweetalert";

export const createMediaInformationAction =
  (hospital_name, type, date_of_surgery, visit_id, branch_id) =>
  async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_MEDIA_INFORMATION_REQUEST,
      payload: [],
    });

    try {
      const response = await api.post(
        "media/create",
        { hospital_name, date_of_surgery, visit_id, status: type, branch_id },
        config
      );
      const { status, data } = response;
      // console.log(response);
      if (status == 201) {
        swal({
          title: "Good job!",
          text: "Media Information was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: CREATE_MEDIA_INFORMATION_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      // console.log(error);
      if (error.response.status == 422) {
        // console.log(error);
        dispatch({
          type: CREATE_MEDIA_INFORMATION_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const updateMediaInformationAction =
  (id, hospital_name, type, date_of_surgery, visit_id, branch_id) =>
  async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_MEDIA_INFORMATION_REQUEST,
      payload: [],
    });

    try {
      const response = await api.put(
        "media/update/" + id,
        { hospital_name, date_of_surgery, visit_id, status: type, branch_id },
        config
      );
      const { status, data } = response;
      // console.log(response);
      if (status == 200) {
        swal({
          title: "Good job!",
          text: "Media Information was update Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: CREATE_MEDIA_INFORMATION_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      // console.log(error);
      if (error.response.status == 422) {
        // console.log(error);
        dispatch({
          type: CREATE_MEDIA_INFORMATION_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const createAllMediaInformationAction =
  (visit_id, branch_id) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_MEDIA_ALL_INFO_PATIENT_REQUEST,
      payload: [],
    });

    try {
      const response = await api.post(
        "media/all/create",
        { visit_id, branch_id },
        config
      );
      const { status, data } = response;
      // console.log(response);
      if (status == 201) {
        swal({
          title: "Good job!",
          text: "Media Information was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: CREATE_MEDIA_ALL_INFO_PATIENT_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      // console.log(error);
      if (error.response.status == 422) {
        // console.log(error);
        dispatch({
          type: CREATE_MEDIA_ALL_INFO_PATIENT_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const udpateAllMediaInformationAction =
  (id, visit_id, branch_id) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_MEDIA_ALL_INFO_PATIENT_REQUEST,
      payload: [],
    });

    try {
      const response = await api.put(
        "media/all/update/" + id,
        { visit_id, branch_id },
        config
      );
      const { status, data } = response;
      console.log(response);
      if (status == 200) {
        swal({
          title: "Good job!",
          text: "Media Information was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: CREATE_MEDIA_ALL_INFO_PATIENT_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      if (error.response.status == 422) {
        // console.log(error);
        dispatch({
          type: CREATE_MEDIA_ALL_INFO_PATIENT_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };
